import InsertEmptySpaceButtonContainer from './InsertEmptySpaceButtonContainer'
import InsertEmptySpaceButton from './InsertEmptySpaceButton'
export { InsertEmptySpaceButton }
export { InsertEmptySpaceButtonContainer }
export default InsertEmptySpaceButtonContainer



// WEBPACK FOOTER //
// ./src/components/InsertEmptySpaceButton/index.js